









































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";

import questionSettingTemplate from "./questionSettingTemplate.vue";
import { choice } from "@modules/newCommunity/pages/operationTools/pages/questionnaireEdit/validateUtils/newIndex";
import draggable from "vuedraggable";
import PicUpload from "@/components/picUpload/index.vue";
import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { getCatalog, EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";

@Component({
  name: "sort",
  components: {
    PicUpload,
    questionSettingTemplate,
    draggable,
    EditSortDialog,
  },
})
export default class sort extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;
  private drag = false;
  private loading = false;
  private catalogList: any[] = [];
  private editSortDialogKey = Math.random();
  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      console.warn("postForm", this.postForm);
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private postForm: any = {
    title: "请选择以下选项", // 标题
    required: "1", // 是否必填
    itemScore: 0, // 标题
    optionContentType: "TEXT", // 是否必填
    correctAnswer: ["1"], // 是否必填
    optionsList: [
      { value: "选项1", content: "选项1", rightOption: true, otherInput: false },
      { value: "选项2", content: "选项2", rightOption: true, otherInput: false },
    ],
    catalogIds: [],
    whetherJoinQuestionBank: false,

    jsonConfig: {
      subTitle: "",
      showIndex: true,
      otherInputForm: "NONE",
      otherInputNumberMin: null,
      otherInputNumberMax: null,
      otherInputNumberPrecision: null,
      otherInputMin: null,
      otherInputMax: null,
      selectRangeMin: null,
      selectRangeMax: null,
    },
  };
  private optionValidator = choice.content;
  private rules = {
    title: [{ required: true, message: "请输入标题", type: "string", trigger: "blur" }],

    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
    itemScore: [{ required: true, message: "请填写题目分值", trigger: "blur" }],
    optionsList: [{ required: true, type: "array", validator: choice.optionsList }],
    // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
    whetherJoinQuestionBank: [{ required: true, message: "请选择是否加入题库", trigger: "blur" }],
    "jsonConfig.selectRangeMin": [{ validator: this.validatorSelectRange }],
    otherInputForm: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
  };
  validatorSelectRange(rule: any, value: any, callback: any) {
    console.log("validatorSelectRange", "validatorSelectRange");
    if (this.postForm.jsonConfig.selectRangeMax && this.postForm.jsonConfig.selectRangeMin && (this.postForm.jsonConfig.selectRangeMin as number) > (this.postForm.jsonConfig.selectRangeMax as number)) {
      callback(new Error("最多应大于最少"));
    } else {
      callback();
    }
  }
  get haveOtherSet(): any {
    return this.postForm.optionsList.some((ot: any) => {
      return ot.otherInput;
    });
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType(): EnumCommunityType {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams(): any {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType,
    };
  }
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }

  removeOption(item: { value: string }, index: number) {
    // let findIndex = this.postForm.correctAnswer.findIndex((answer: string) => {
    //   return answer == item.value;
    // });
    // if (findIndex >= 0) {
    //   this.postForm.correctAnswer.splice(findIndex, 1);
    // }
    this.postForm.optionsList.splice(index, 1);
    this.emitChange();
  }
  optionContentTypeChange() {
    this.postForm.optionsList.forEach((item: any) => {
      item.content = "";
      item.otherInput = false;
    });
  }
  addOption(otherInput: boolean) {
    const str = this.postForm.optionContentType == "TEXT" ? "选项" + (this.postForm.optionsList.length + 1) : "";
    this.postForm.optionsList.push({ value: str, content: otherInput ? "其它" : str, rightOption: false, otherInput: otherInput });
    this.emitChange();
  }
  getFormInstance() {
    return this.$refs.postForm as any;
  }
  validateOptions() {
    this.getFormInstance().validateField("optionsList");
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
  remoteMethod(query?: any) {
    this.loading = true;
    getCatalog({ ...this.basicParams, name: query, pageSize: 50, pageNum: 1 })
      .then((res: any) => {
        this.catalogList = res.rows || [];
      })
      .finally(() => (this.loading = false));
  }
  catalogFocus() {
    if (this.catalogList.length === 0) {
      this.remoteMethod();
    }
  }
  openSortDialog() {
    (this.$refs.editSortDialog as any).onShow({ isBusinessTypeDisable: true, formData: { businessType: this.questionnaireType } });
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  // $ 开始拖拽
  onStart() {
    this.drag = true;
  }
  // $ 结束拖拽
  onEnd() {
    this.drag = false;
    this.emitChange();
  }
}
